module.exports = __webpack_public_path__ + "static/apple-touch-icon-6641bdad7eede246421232ad9bd017c0.png";